import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProof() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 0.7
  }} className="mt-8 md:mt-14 max-w-md mx-auto" data-id="element-114">
      <div className="flex items-center justify-center gap-1 mb-2" data-id="element-115">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 fill-gold text-gold" data-id="element-116" />)}
        <span className="text-white font-bold ml-2 text-sm md:text-base" data-id="element-117">
          4.9/5
        </span>
      </div>

      <p className="font-bold text-white text-base md:text-lg mb-0.5" data-id="element-118">
        Elegido por abogados en toda Argentina
      </p>
      <p className="text-gray-400 text-xs md:text-sm mb-5 md:mb-8" data-id="element-119">
        El sistema de gestión para estudios jurídicos más completo y profesional
        del mercado
      </p>

      <div className="grid grid-cols-2 gap-2 md:gap-4" data-id="element-120">
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-121">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-122">+800</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-123">
            Profesionales confían en el sistema
          </p>
        </div>
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-124">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-125">4.9/5</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-126">
            Valoración promedio
          </p>
        </div>
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-127">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-128">+180</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-129">
            Recursos legales y plantillas
          </p>
        </div>
        <div className="bg-navy-light rounded-lg md:rounded-xl p-3 md:p-4 border border-gold/10" data-id="element-130">
          <p className="text-2xl md:text-4xl font-black text-gold" data-id="element-131">#1</p>
          <p className="text-gray-400 text-xs md:text-sm mt-0.5" data-id="element-132">
            Sistema elegido en Argentina
          </p>
        </div>
      </div>
    </motion.div>;
}